import styled from "@emotion/styled";
import { FadeIn } from "./FadeIn";

type DropdownProps = {
  children: React.ReactNode;
  isOpen: boolean;
  id?: string;
};

function DropdownMenu({ children, isOpen, id, ...props }: DropdownProps) {
  return (
    <DropdownElement
      isOpen={isOpen}
      hidden={!isOpen}
      className="DropdownMenu"
      aria-live={isOpen ? "polite" : "off"}
      id={id ?? ""}
      {...props}
    >
      <DropdownMenuNav>{children}</DropdownMenuNav>
    </DropdownElement>
  );
}

const DropdownElement = styled(FadeIn)<{ isOpen: boolean }>(
  ({ isOpen, theme }) => ({
    // display: isOpen ? "block" : "none",
    background: theme.colors.bg,
    borderRadius: theme.borderRadius.sm,
    boxShadow: theme.boxShadow.dark,
    padding: "1rem",
    position: "absolute",
    right: 0,
    textAlign: "left",
    top: "100%",
    width: "max-content",
    zIndex: 10,
  })
);

const DropdownMenuNav = styled.nav(({ theme }) => ({
  "*+*": {
    marginTop: ".66rem",
  },
  "&,ul": {
    display: "flex",
    flexDirection: "column",
    gap: ".66rem",
  },
  li: {
    backgroundColor: "rgb(0 0 0 / 0)",
    padding: 0,
    borderRadius: 0,
    margin: 0,
    textAlign: "left",
    display: "inline-block",
    textDecoration: "none",
    lineHeight: 1.2,
    'a, button, & [role="button"], & clipboard-copy': {
      ...theme.fonts.display,
      borderBottom: `2px solid ${theme.colors.transparent}`,
      color: theme.colors.fg,
      transition: "none",
      fontSize: theme.fontSizes.xs,
      textDecoration: "none",
      textTransform: "uppercase",
      fontWeight: "normal",
      display: "inline-flex",
      cursor: "pointer",
      gap: 6,
      span: {
        width: "1.2em",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      "&:hover, &:focus-visible": {
        color: theme.colors.fg,
        textDecoration: "none",
        borderBottom: "2px solid currentColor",
      },
    },
  },
}));

export { DropdownMenu };
